/* eslint-disable max-len */
/* eslint-disable no-unused-expressions */
/* eslint-disable radix */
import { saveAs } from 'file-saver';
import XLSX from 'tempa-xlsx';
import { min2time } from '../../../../../helpers/utils';
import { strToArrBuffer } from './DataUtil';
import exportsFormulas from '../../../../CompanyExports/exportsFormulas';

function formatRattrapageData(dataPdf, elearningDuration, elearningTarget, elearningAttempts, elearningDurationTarget, ponderation) {
  const finalData = [];

  if (dataPdf.rattrapage !== null && dataPdf.rattrapage !== undefined) {
    dataPdf.rattrapage.data.forEach((element) => {
      // const quizPercent = parseInt(element.percent.toFixed(), 10);
      // let quizTarget = 0;
      // const unitsPercent = parseInt(element.unitsPercent.toFixed(), 10);
      // let unitsTarget = 0;
      // const timePercent = parseInt(element.time.toFixed(), 10);
      // let timeTarget = 0;
      // let nbCriterias = 0;
      // if (elearningDuration && elearningDuration > 0 && elearningDurationTarget && elearningDurationTarget > 0) {
      //   nbCriterias += 1;
      //   timeTarget = parseInt(elearningDuration, 10) * 60;
      //   timeTarget *= elearningDurationTarget / 100;
      //   targetData = timeTarget;
      // }
      // if (elearningTarget && elearningTarget > 0) {
      //   nbCriterias += 1;
      //   quizTarget = parseInt(elearningTarget, 10);
      // }
      // if (elearningAttempts && elearningAttempts > 0) {
      //   nbCriterias += 1;
      //   unitsTarget = parseInt(elearningAttempts, 10);
      // }

      // const quizNote = (quizPercent / quizTarget) * 10 >= 10 ? 10 : (quizPercent / quizTarget) * 10;
      // const unitsNote = (unitsPercent / unitsTarget) * 10 >= 10 ? 10 : (unitsPercent / unitsTarget) * 10;
      // const timeNote = (timePercent / timeTarget) * 10 >= 10 ? 10 : (timePercent / timeTarget) * 10;
      // let note = ((elearningTarget && elearningTarget > 0 ? quizNote : 0) + (elearningAttempts && elearningAttempts > 0 ? unitsNote : 0) + (elearningDuration && elearningDuration > 0 && elearningDurationTarget && elearningDurationTarget > 0 ? timeNote : 0)) / nbCriterias;
      // note *= 100;
      // note -= note % 1;
      // note /= 100;

      const { note } = exportsFormulas.rattrapageFormula(element, elearningTarget, elearningAttempts, elearningDuration);
      const rowData = [];

      rowData.push({ value: element.name });
      rowData.push({ value: element.firstname });
      rowData.push({ value: `${element.percent.toFixed()}%` });
      rowData.push({ value: `${element.unitsPercent.toFixed()}%` });
      rowData.push({ value: min2time(element.time) });
      rowData.push({ value: note.toFixed(2) });
      if (element.grade) {
        let examGradeArr = 0;
        let total = 0;
        if (element.catchUpGrade) {
          examGradeArr = Object.values(element.catchUpGrade);
          total = element.catchUpTotal;
        } else {
          examGradeArr = Object.values(element.grade);
          total = element.total;
        }
        const reduced = examGradeArr.reduce((sum, val) => sum + (val || 0), 0);
        const examGrade = ((reduced / total) * 20).toFixed(2);
        const gradePond = (((examGrade / 100) * ponderation.exams) + ((note / 100) * ponderation.elearning)).toFixed(2);
        rowData.push(examGrade);
        rowData.push(gradePond);
      } else {
        rowData.push('n/a');
        rowData.push('n/a');
      }
      finalData.push(rowData);
    });
  }

  const style = { font: { bold: true }, fill: { patternType: 'solid', fgColor: { rgb: 'FF5972FF' } } };
  return [{
    columns: [
      { title: 'Nom', width: { wch: 20 }, style },
      { title: 'Prenom', width: { wch: 20 }, style },
      { title: `Réussite aux quizs (${elearningTarget}%)`, width: { wch: 25 }, style },
      { title: `Réalisation du programme (${elearningAttempts}%)`, width: { wch: 25 }, style },
      { title: `Temps de connexion (${min2time(elearningDuration)})`, width: { wch: 20 }, style },
      { title: `Note e-learning (/20) ${ponderation.elearning}%`, width: { wch: 20 }, style },
      { title: `Note examen (/20) ${ponderation.exams}%`, width: { wch: 20 }, style },
      { title: 'Note pondérée (/20)', width: { wch: 20 }, style },
    ],
    data: finalData,
  }];
}

function formatSuccessData(dataPdf, elearningDuration, elearningTarget, elearningAttempts, elearningDurationTarget, ponderation) {
  const finalData = [];

  if (dataPdf.success !== null && dataPdf.success !== undefined) {
    dataPdf.success.data.forEach((element) => {
      // const quizPercent = parseInt(element.percent.toFixed(), 10);
      // let quizTarget = 0;
      // const unitsPercent = parseInt(element.unitsPercent.toFixed(), 10);
      // let unitsTarget = 0;
      // const timePercent = parseInt(element.time.toFixed(), 10);
      // let timeTarget = 0;
      // let nbCriterias = 0;
      // if (elearningDuration && elearningDuration > 0 && elearningDurationTarget && elearningDurationTarget > 0) {
      //   nbCriterias += 1;
      //   timeTarget = parseInt(elearningDuration, 10) * 60;
      //   timeTarget *= elearningDurationTarget / 100;
      //   targetData = timeTarget;
      // }
      // if (elearningTarget && elearningTarget > 0) {
      //   nbCriterias += 1;
      //   quizTarget = parseInt(elearningTarget, 10);
      // }
      // if (elearningAttempts && elearningAttempts > 0) {
      //   nbCriterias += 1;
      //   unitsTarget = parseInt(elearningAttempts, 10);
      // }

      // const quizNote = (quizTarget === 100 ? 1 : ((quizPercent - quizTarget) / (100 - quizTarget))) * 10;
      // const unitsNote = (unitsTarget === 100 ? 1 : ((unitsPercent - unitsTarget) / (100 - unitsTarget))) * 10;
      // const timeNote = (timeTarget === 100 || timePercent >= timeTarget ? 1 : ((timePercent - timeTarget) / (100 - timeTarget))) * 10;
      // let note = (((quizTarget > 0 ? quizNote : 0) + (unitsTarget > 0 ? unitsNote : 0) + (timeTarget > 0 ? timeNote : 0)) / nbCriterias) + 10;
      // note *= 100;
      // note -= note % 1;
      // note /= 100;
      const { note } = exportsFormulas.successFormula(element, elearningTarget, elearningAttempts, elearningDuration);
      const rowData = [];

      rowData.push({ value: element.name });
      rowData.push({ value: element.firstname });
      rowData.push({ value: `${element.percent.toFixed()}%` });
      rowData.push({ value: `${element.unitsPercent.toFixed()}%` });
      rowData.push({ value: min2time(element.time) });
      rowData.push({ value: note.toFixed(2) });
      if (element.grade || element.catchUpGrade) {
        let examGradeArr = 0;
        let total = 0;
        if (element.catchUpGrade) {
          examGradeArr = Object.values(element.catchUpGrade);
          total = element.catchUpTotal;
        } else {
          examGradeArr = Object.values(element.grade);
          total = element.total;
        }
        const reduced = examGradeArr.reduce((sum, val) => sum + (val || 0), 0);
        const examGrade = ((reduced / total) * 20).toFixed(2);
        const gradePond = (((examGrade / 100) * ponderation.exams) + ((note / 100) * ponderation.elearning)).toFixed(2);
        rowData.push(examGrade);
        rowData.push(gradePond);
      } else {
        rowData.push('n/a');
        rowData.push('n/a');
      }
      finalData.push(rowData);
    });
  }
  const style = { font: { bold: true }, fill: { patternType: 'solid', fgColor: { rgb: 'FF21B12E' } } };
  return [{
    columns: [
      { title: 'Nom', width: { wch: 20 }, style },
      { title: 'Prenom', width: { wch: 20 }, style },
      { title: `Réussite aux quizs (${elearningTarget}%)`, width: { wch: 25 }, style },
      { title: `Réalisation du programme (${elearningAttempts}%)`, width: { wch: 25 }, style },
      { title: `Temps de connexion (${min2time(elearningDuration)})`, width: { wch: 20 }, style },
      { title: `Note e-learning (/20) ${ponderation.elearning}%`, width: { wch: 20 }, style },
      { title: `Note examen (/20) ${ponderation.exams}%`, width: { wch: 20 }, style },
      { title: 'Note pondérée (/20)', width: { wch: 20 }, style },
    ],
    data: finalData,
  }];
}

function formatNoTrackData(dataPdf, ponderation) {
  const finalData = [];

  if (dataPdf.notrack !== null && dataPdf.notrack !== undefined) {
    dataPdf.notrack.data.forEach((element) => {
      const rowData = [];
      rowData.push({ value: element.name });
      rowData.push({ value: element.firstname });
      rowData.push({ value: 'Jamais connecté(e)' });
      rowData.push({ value: 'Jamais connecté(e)' });
      rowData.push({ value: 'Jamais connecté(e)' });
      rowData.push({ value: '0' });

      if (element.grade || element.catchUpGrade) {
        let examGradeArr = 0;
        let total = 0;
        if (element.catchUpGrade) {
          examGradeArr = Object.values(element.catchUpGrade);
          total = element.catchUpTotal;
        } else {
          examGradeArr = Object.values(element.grade);
          total = element.total;
        }
        const reduced = examGradeArr.reduce((sum, val) => sum + (val || 0), 0);
        const examGrade = ((reduced / total) * 20).toFixed(2);
        const gradePond = (((examGrade / 100) * ponderation.exams) + ((0 / 100) * ponderation.elearning)).toFixed(2);
        rowData.push(examGrade);
        rowData.push(gradePond);
      } else {
        rowData.push(0);
        rowData.push(0);
      }

      finalData.push(rowData);
    });
  }

  return [{
    columns: [
      { title: 'Nom', width: { wch: 20 }, style: { font: { bold: true }, fill: { patternType: 'solid', fgColor: { rgb: 'FFFF0000' } } } },
      { title: 'Prenom', width: { wch: 20 }, style: { font: { bold: true }, fill: { patternType: 'solid', fgColor: { rgb: 'FFFF0000' } } } },
      { title: 'Email', width: { wch: 40 }, style: { font: { bold: true }, fill: { patternType: 'solid', fgColor: { rgb: 'FFFF0000' } } } },
    ],
    data: finalData,
  }];
}

function generateExcel(wb, name) {
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
  saveAs(new Blob([strToArrBuffer(excelBuffer)], { type: fileType }), name);
}

const excelGen = {
  formatNoTrackData, formatRattrapageData, formatSuccessData, generateExcel,
};

export default excelGen;
